import { chain } from 'lodash';

const FIT_MAPPING: Record<string, string> = {
  crop: 'crop',
  fill: 'cover',
  max: 'scale-down',
  min: 'contain',
};

const IGNORED_PARAMS = new Set(['auto', 'ch', 'ixlib', 's', 'expires', 'w', 'h', 'dpr']);

// implementation of imgix-url filter for non-angular environment
export default function(imgixFileAndParams: string): string {
  const [imgixFilename, imgixParamsString] = imgixFileAndParams.split('?');

  let imgixParams: Record<string, string> = {};
  if (imgixParamsString) {
    imgixParams = chain(imgixParamsString)
      .split('&')
      .map(param => param.split('='))
      .fromPairs()
      .value();
  }

  const defaultImgixParams: Record<string, string> = {
    fit: 'max', // use the `w` and `h` params as maximums
  };

  const mergedParams: Record<string, string> = { ...defaultImgixParams, ...imgixParams };

  const outputParams: string[] = ['service=consumer'];

  Object.keys(mergedParams).sort().forEach((key: string) => {
    if (IGNORED_PARAMS.has(key)) {
      return;
    }
    let value = mergedParams[key];
    if (key === 'fit') {
      value = FIT_MAPPING[value] || value;
    }
    outputParams.push(`${key}=${value}`);
  });

  return `https://images.opendoor.com/source/s3/imgdrop-production/${imgixFilename}?${outputParams.join('&')}`;
}
